import { library as FontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core'

import { faCaretDown } from '@fortawesome/pro-solid-svg-icons'
import { faCaretRight } from '@fortawesome/pro-light-svg-icons'

import { faComment } from '@fortawesome/pro-solid-svg-icons'
import { faComments } from '@fortawesome/pro-solid-svg-icons'
import { faComments as faCommentsLight } from '@fortawesome/pro-light-svg-icons'


import { faArrowCircleRight } from '@fortawesome/pro-light-svg-icons'
import { faArrowDown } from '@fortawesome/pro-light-svg-icons'
import { faArrowToBottom as faArrowToBottomLight } from '@fortawesome/pro-light-svg-icons'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons'

import { faExternalLink } from '@fortawesome/pro-light-svg-icons'

import { faPlayCircle } from '@fortawesome/pro-solid-svg-icons'
import { faPlayCircle as faPlayCircleRegular } from '@fortawesome/pro-regular-svg-icons'
import { faPlayCircle as faPlayCircleLight } from '@fortawesome/pro-light-svg-icons'

import { faPlusCircle as faPlusCircleLight } from '@fortawesome/pro-light-svg-icons'

import { faAngleDoubleRight } from '@fortawesome/pro-solid-svg-icons'
import { faAngleDoubleRight as faAngleDoubleRightLight } from '@fortawesome/pro-light-svg-icons'

import { faAngleUp as faAngleUpLight } from '@fortawesome/pro-light-svg-icons'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'
import { faAngleRight as faAngleRightRegular } from '@fortawesome/pro-regular-svg-icons'

import { faArrowRight as faArrowRightLight } from '@fortawesome/pro-light-svg-icons'
import { faArrowLeft as faArrowLeftLight } from '@fortawesome/pro-light-svg-icons'


import { faAngleLeft } from '@fortawesome/pro-light-svg-icons'
import { faAngleLeft as faAngleLeftLight } from '@fortawesome/pro-light-svg-icons'

import { faPlay } from '@fortawesome/pro-light-svg-icons'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

import { faFile } from '@fortawesome/pro-solid-svg-icons'
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons'
import { faFilePdf as faFilePdfLight } from '@fortawesome/pro-light-svg-icons'

import { faCampground as faCampgroundRegular } from '@fortawesome/pro-regular-svg-icons'
import { faSquare } from '@fortawesome/pro-solid-svg-icons'
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons'
import { faEnvelope as faEnvelopeLight } from '@fortawesome/pro-light-svg-icons'
import { faCertificate } from '@fortawesome/pro-solid-svg-icons'
import { faHeart } from '@fortawesome/pro-solid-svg-icons'
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { faCheck as faCheckLight } from '@fortawesome/pro-light-svg-icons'
import { faExpand as faExpandLight } from '@fortawesome/pro-light-svg-icons'
import { faSearchPlus } from '@fortawesome/pro-light-svg-icons'
import { faCompass as faCompassLight } from '@fortawesome/pro-light-svg-icons'
import { faCalendar } from '@fortawesome/pro-light-svg-icons'
import { faEdit } from '@fortawesome/pro-light-svg-icons'
import { faMap as faMapLight } from '@fortawesome/pro-light-svg-icons'
import { faClone } from '@fortawesome/pro-light-svg-icons'
import { faSignOut } from '@fortawesome/pro-light-svg-icons'
import { faBullhorn } from '@fortawesome/pro-solid-svg-icons'
import { faExclamation } from '@fortawesome/pro-solid-svg-icons'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import { faBell } from '@fortawesome/pro-solid-svg-icons'
import { faPhone } from '@fortawesome/pro-solid-svg-icons'
import { faEye } from '@fortawesome/pro-solid-svg-icons'
import { faBookOpen } from '@fortawesome/pro-solid-svg-icons'
import { faBookOpen as faBookOpenLight } from '@fortawesome/pro-light-svg-icons'
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons'
import { faLocationArrow } from '@fortawesome/pro-solid-svg-icons'
import { faShoppingBag as faShoppingBagLight } from '@fortawesome/pro-light-svg-icons'
import { faGift as faGiftLight } from '@fortawesome/pro-light-svg-icons'
import { faLeaf } from '@fortawesome/pro-light-svg-icons'
import { faShoppingCart as faShoppingCartLight } from '@fortawesome/pro-light-svg-icons'
import { faCircleNotch as faCircleNotchLight } from '@fortawesome/pro-light-svg-icons'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faVimeo } from '@fortawesome/free-brands-svg-icons'
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons'
import { faPinterest } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


FontAwesomeLibrary.add(faExternalLink,faArrowRight,faCaretDown,faArrowToBottomLight,faCaretRight, faBell, faEnvelope,faEnvelopeLight,faFilePdf,faFacebookSquare,faPinterest,faTwitter,faPlayCircle,faPlayCircleRegular, faPlayCircleLight,faInstagram,faComment,faComments,faCommentsLight,faSearchPlus,faAngleLeftLight,faFilePdfLight,faGiftLight,faShoppingCartLight,faAngleDoubleRight,faShoppingBagLight,faAngleRight,faAngleRightRegular,faAngleLeft,faSignOut,faCompassLight,faAngleDoubleRightLight,faPlay,faTimes,faLeaf,faArrowCircleRight,faLocationArrow,faEye,faArrowDown,faCheck,faCheckLight,faStarSolid,faArrowRightLight,faArrowLeftLight,faAngleUpLight,faCampgroundRegular,faCircle,faYoutube,faVimeo,faHeart,faFile,faSquare,faBookOpen,faPaperPlane,faCertificate,faExclamation,faExclamationTriangle,faBullhorn,faEdit,faCalendar,faPlusCircleLight,faExpandLight,faMapLight,faClone,faCheckSquare,faPhone,faCircleNotchLight,faBookOpenLight);

// itinerary
import { faPlane } from '@fortawesome/pro-solid-svg-icons'
import { faGlassMartiniAlt } from '@fortawesome/pro-solid-svg-icons'
import { faShuttleVan } from '@fortawesome/pro-solid-svg-icons'
import { faUtensils } from '@fortawesome/pro-solid-svg-icons'
import { faWineGlass } from '@fortawesome/pro-solid-svg-icons'
import { faGuitar } from '@fortawesome/pro-solid-svg-icons'
import { faGuitars } from '@fortawesome/pro-solid-svg-icons'
import { faSpa } from '@fortawesome/pro-solid-svg-icons'
import { faBagShopping } from '@fortawesome/pro-solid-svg-icons'
import { faHatChef } from '@fortawesome/pro-solid-svg-icons'
import { faSparkles } from '@fortawesome/pro-solid-svg-icons'
import { faHorse } from '@fortawesome/pro-solid-svg-icons'
import { faTrophy } from '@fortawesome/pro-solid-svg-icons'
import { faAsterisk } from '@fortawesome/pro-solid-svg-icons'
import { faDiamond } from '@fortawesome/pro-solid-svg-icons'
import { faCampfire } from '@fortawesome/pro-solid-svg-icons'
import { faCampground } from '@fortawesome/pro-solid-svg-icons'
import { faFire } from '@fortawesome/pro-solid-svg-icons'
import { faCompass } from '@fortawesome/pro-solid-svg-icons'
import { faHiking } from '@fortawesome/pro-solid-svg-icons'
import { faMap } from '@fortawesome/pro-solid-svg-icons'
import { faMapSigns } from '@fortawesome/pro-solid-svg-icons'
import { faMountains } from '@fortawesome/pro-solid-svg-icons'
import { faTreeLarge } from '@fortawesome/pro-solid-svg-icons'
import { faBackpack } from '@fortawesome/pro-solid-svg-icons'
import { faCurling } from '@fortawesome/pro-solid-svg-icons'
import { faPaintBrush } from '@fortawesome/pro-solid-svg-icons'
import { faAxe } from '@fortawesome/pro-solid-svg-icons'
import { faPopcorn } from '@fortawesome/pro-solid-svg-icons'
import { faPizzaSlice } from '@fortawesome/pro-solid-svg-icons'
import { faRing } from '@fortawesome/pro-solid-svg-icons'
import { faCamera } from '@fortawesome/pro-solid-svg-icons'
import { faEgg } from '@fortawesome/pro-solid-svg-icons'
import { faGameBoard } from '@fortawesome/pro-solid-svg-icons'
import { faFish } from '@fortawesome/pro-solid-svg-icons'
import { faBook } from '@fortawesome/pro-solid-svg-icons'
import { faBroom } from '@fortawesome/pro-solid-svg-icons'
import { faFootballBall } from '@fortawesome/pro-solid-svg-icons'
import { faDice } from '@fortawesome/pro-solid-svg-icons'
import { faBeerMug } from '@fortawesome/pro-solid-svg-icons'

FontAwesomeLibrary.add(faPlane,faGlassMartiniAlt,faShuttleVan,faUtensils,faWineGlass,faGuitar,faGuitars,faSpa,faBagShopping,faHatChef,faSparkles,faHorse,faTrophy,faAsterisk,faDiamond,faCampfire,faCampground,faFire,faCompass,faHiking,faMap,faMapSigns,faMountains,faTreeLarge,faBackpack,faCurling,faPaintBrush,faAxe,faPopcorn,faPizzaSlice,faRing, faCamera,faGameBoard,faEgg,faFish,faBook,faBroom,faFootballBall,faDice,faBeerMug)
